import { useSyncExternalStore } from 'react'
import { accountProfileStore } from '../services/accountProfileStore'

/**
 * Home greeting / Sidenav footer 用の display name フック。
 *
 * `accountProfileStore` を購読し、`getDisplayName()` の最新値を返す。
 * store が空なら mount 時に GET /users/me を 1 度発火する (重複発火しない)。
 */
export const useDisplayName = (): string =>
  useSyncExternalStore(
    accountProfileStore.subscribe,
    accountProfileStore.getDisplayName,
    accountProfileStore.getDisplayName,
  )
